import {tryGeneratePath} from "../../../routing/routing.utils.ts";
import React from "react";
import {useStores} from "../../../stores";
import {useParams} from "react-router";
import MithraMainLogo from '../../../icons/logo/MithraMainLogo.svg?react';
import MithraLogo from '../../../icons/logo/MithraLogo.svg?react';
import type {RouteKey} from "../../../routing/routes.ts";
import {MLink} from "../../_tiny/MLink.tsx";

type Props = {
    collapsed?: boolean
    route?: RouteKey
}
export const DrawerMainLogo: React.FC<Props> = ({collapsed, route}) => {
    const {p, bagStore} = useStores();
    const params = useParams();
    const path = tryGeneratePath(params, route ?? 'homepage_dashboard', bagStore.bag?.id);

    return <MLink path={path} className="main-logo-menu-item" fallbackComponent="div">
        {collapsed ? <MithraLogo style={{marginBottom: '32px'}} width={36} height={36}/> :
            <MithraMainLogo style={{marginBottom: '32px', marginLeft: '4px'}} width={162} height={36}/>}
        {/* {p.p.branding === 'nexo' && <img src="/logo/NExO_logo_v4_02_h60.png" alt="NExO" className="nexo-logo"/>} */}
    </MLink>
}